import reducers from './teamFeatureReducers';

export default reducers;



// WEBPACK FOOTER //
// ./src/state/reducers/team/index.js